import * as yup from "yup";
var EMAIL_REGEX = /^[a-zA-Z0-9.'_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
export var loginValidationSchema = yup.object({
    email: yup.string().matches(EMAIL_REGEX, "Invalid email").required(),
    password: yup.string().required(), //TODO: this actually won't be required if using SSO with Microsoft
});
export var emailValidationSchema = yup.object({
    email: yup.string().matches(EMAIL_REGEX, "Invalid email").required(),
});
// TODO:user-flow-GA: remove the confirmPassword field from the schema
// delete registerValidationSchemaNoRequire
export var registerValidationSchema = yup.object({
    email: yup.string().matches(EMAIL_REGEX, "Invalid email").required(),
    firstName: yup.string().required().label("First Name"),
    lastName: yup.string().required().label("Last Name"),
    jobTitle: yup.string().required().label("Company Role"),
    password: yup.string().required().label("Password"),
    confirmPassword: yup
        .string()
        .required()
        .oneOf([yup.ref("password"), null], "Passwords don't match")
        .label("Confirm Password"),
    agree: yup.bool().oneOf([true], "Please accept the terms of service!"),
});
export var registerValidationSchemaNoPassConfirm = yup.object({
    email: yup.string().matches(EMAIL_REGEX, "Invalid email").required(),
    firstName: yup.string().required().label("First Name"),
    lastName: yup.string().required().label("Last Name"),
    jobTitle: yup.string().required().label("Company Role"),
    password: yup.string().required().label("Password"),
    agree: yup.bool().oneOf([true], "Please accept the terms of service!"),
});
